import { render, staticRenderFns } from "./completionAcceptance.vue?vue&type=template&id=1fd22590&scoped=true&"
import script from "./completionAcceptance.vue?vue&type=script&lang=js&"
export * from "./completionAcceptance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd22590",
  null
  
)

export default component.exports